import BaseContent from '@model/content/BaseContent'
import SliderScaleStep from '@model/content/SliderScaleStep'

class PainScaleStep extends SliderScaleStep {
    constructor(object) {
        super({
            slug: object.slug,
            type: BaseContent.Type.painScale,
            title: object.title,
            text: object.text,
            answerFormat: {
                sliderMinValue: 0,
                sliderMaxValue: 10,
                hideNumbers: false
            },
            version: object.version,
            locale: object.locale
        })
    }
}

export default PainScaleStep
